import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`


    @font-face {
        font-family: 'SourceSansProBlack';
        src: url('./fonts/SourceSansPro-Black.otf') format('opentype');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'SourceSansProNormal';
        src: url('./fonts/SourceSansPro-Regular.otf') format('opentype');
        font-weight: normal;
        font-style: normal;
    }

    body,
    html,
    a {
        font-family: 'SourceSansProNormal', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
        font-family: 'SourceSansProNormal';
    }

    a:hover {
        color: #1D1B20;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'SourceSansProNormal', serif;
        color: #1D1B20;
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: #1D1B20;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #1D1B20;

        :hover {
            color: #1D1B20;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }

    .section-full {
  max-width: none !important;
  padding: 10 !important;
}
`;
